module.exports = __webpack_public_path__ + "img/MarieChinnici-Everitt@2x.41515a78.png";